/**
 *  @class
 *  @function FacetsToggle
 */

class FacetToggle extends HTMLElement {

  constructor() {
    super();
    this.init();
  }
  init() {
    this.drawer = document.getElementById('Facet-Drawer');
    this.container = this.closest('.facets--bar-sticky');

    // Add functionality to buttons
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
    });
    if (this.container) {
      this.enableSticky();
    }
  }
  enableSticky() {
    let rootMargin = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) + 1;
    this.observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
      {
        threshold: [1],
        rootMargin: `-${rootMargin}px 0px 0px 0px`
      }
    );

    this.observer.observe(this.container);
  }

}
customElements.define('facet-toggle', FacetToggle);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if (event.target.id === 'compare_toggle') {
        return;
      }
      this.onSubmitHandler(event);
    }, 500);

    this.form = this.querySelector('form');
    // Si ce n’est pas le formulaire mobile, on écoute les 'input'
    // if (this.form.id === 'FacetFiltersForm') {
    if (this.form) {
      this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
    
    setTimeout(() => {
      reopenActiveFilterGroups();
    }, 50);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // 1. Récupérer les filtres du formulaire
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);

    // 2. Nettoyer (exemple : prix mini 0, prix maxi = max slider)
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      const maxPrice = document.querySelector('.price_slider').dataset.max;
      if (searchParams.get('filter.v.price.lte') === parseFloat(maxPrice).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }

    // 3. Fusionner avec l’URL actuelle (pour garder sort_by, compare_toggle, etc.)
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((val, key) => {
      // Si la nouvelle liste de params ne contient pas déjà "key",
      // on récupère la valeur existante (ex : sort_by)
      if (!searchParams.has(key)) {
        searchParams.set(key, val);
      }
    });

    // 4. Appeler la mise à jour de page avec les paramètres combinés
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1
      ? ''
      : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function Facetremove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.compareToggle = this.querySelector('#compare_toggle');
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
    return false;
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    
    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

function isFilterGroupOpen(filterGroupId) {
  return localStorage.getItem(`filter-group-${filterGroupId}`) === 'true';
}

document.addEventListener('DOMContentLoaded', () => {
  const filterDetails = document.querySelectorAll('details[data-filter-group-id]');

  filterDetails.forEach(detail => {
    detail.addEventListener('toggle', () => {
      const filterGroupId = detail.dataset.filterGroupId;
      localStorage.setItem(`filter-group-${filterGroupId}`, detail.open);
    });
  });
});

function reopenActiveFilterGroups() {
  console.trace('Trace de l\'appel');
  // Gestion existante des checkboxes cochées
  const activeFilters = document.querySelectorAll('form .thb-filter-content input[type="checkbox"]:checked');

  // On traite d'abord les checkboxes comme avant
  activeFilters.forEach((checkbox) => {
    let current = checkbox.parentElement;
    while (current) {
      if (current.matches && current.matches('details.thb-filter.js-filter')) {
        current.setAttribute('open', 'open');
      }
      current = current.parentElement;
    }
  });

  // Gestion des tags sélectionnés
  const activeTagFilters = document.querySelectorAll('.filter-tag.selected');
  
  // Pour chaque tag sélectionné
  activeTagFilters.forEach((tag) => {
    // On remonte jusqu'au details parent le plus proche
    let detailsParent = tag.closest('details.thb-filter.js-filter');
    if (detailsParent) {
      detailsParent.setAttribute('open', 'open');
      
      // On continue de remonter pour trouver le details du groupe parent
      let groupParent = detailsParent.closest('collapsible-row');
      if (groupParent && groupParent.querySelector('details')) {
        groupParent.querySelector('details').setAttribute('open', 'open');
      }
    } else {
      let current = tag.parentElement;
      let i = 0;
      while (current && i < 5) {
        current = current.parentElement;
        i++;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const mobileApplyButton = document.querySelector('.mobile-filters-apply');
  if (mobileApplyButton) {
    mobileApplyButton.addEventListener('click', (e) => {
      e.preventDefault();

      const mobileForm = document.getElementById('FacetFiltersFormMobile');
      if (!mobileForm) return;

      const formData = new FormData(mobileForm);
      const searchParams = new URLSearchParams(formData);

      // Gérer les prix comme avant
      if (searchParams.get('filter.v.price.gte') === "0.00") {
        searchParams.delete('filter.v.price.gte');
      }
      if (document.querySelector('.price_slider')) {
        if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
          searchParams.delete('filter.v.price.lte');
        }
      }

      // Ajouter les tags sélectionnés aux paramètres
      const selectedTags = Array.from(document.querySelectorAll('.facet-drawer .filter-tag.selected'))
        .map(tag => tag.dataset.tag);

      if (selectedTags.length > 0) {
        const { base } = window.tagFilters.extractCollectionAndTags();
        const newUrl = `${base}/${selectedTags.join('+')}`;
        window.history.pushState({}, '', newUrl);
      }

      // Appeler FacetFiltersForm.renderPage avec les paramètres du formulaire mobile
      FacetFiltersForm.renderPage(searchParams.toString(), null);

      // Fermer le drawer
      document.body.classList.remove('open-cc');
      const drawer = document.getElementById('Facet-Drawer');
      if (drawer) {
        drawer.classList.remove('active');
      }
    });
  }
});


/**
 *  @class
 *  @function TagFilters
 */
class TagFilters {
  constructor() {
    this.initialize();
    this.setupDelegatedListener();
    this.setupMutationObserver();
  }

  setupDelegatedListener() {
    document.addEventListener('click', (event) => {
      // Gérer les clicks sur les tags
      const filterButton = event.target.closest('.filter-tag');
      if (filterButton) {
        this.handleTagClick(event, filterButton);
        return;
      }

      // Gérer le bouton "Tout supprimer"
      const clearButton = event.target.closest('.active-facets__button-remove');
      if (clearButton) {
        const { tags } = this.extractCollectionAndTags();
        if (tags.length > 0) {
          event.preventDefault();
          // On garde la query string
          window.location = this.getBaseCollectionUrl() + window.location.search;
        }
      }
    });
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          const hasFilters = Array.from(mutation.addedNodes).some(node => {
            return node.nodeType === 1 && (
              node.classList?.contains('facets__tags-wrapper') ||
              node.querySelector?.('.facets__tags-wrapper') ||
              node.classList?.contains('active-facets')
            );
          });
          
          if (hasFilters) {
            this.updateButtonStates();
            this.updateActiveFacets();
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', () => {
      this.updateButtonStates();
      this.updateActiveFacets();
    });
  }

  initialize() {
    this.updateButtonStates();
    this.updateActiveFacets();
  }

  getBaseCollectionUrl() {
    const { base } = this.extractCollectionAndTags();
    return base;
  }

  extractCollectionAndTags(url = window.location.href) {
    const urlObj = new URL(url);
    const pathParts = urlObj.pathname.split('/').filter(Boolean);
    
    const collectionsIndex = pathParts.indexOf('collections');
    if (collectionsIndex === -1) return { base: '', tags: [] };
    
    const basePathParts = pathParts.slice(0, collectionsIndex + 2);
    const base = '/' + basePathParts.join('/');
    
    const tagsPart = pathParts.slice(collectionsIndex + 2);
    const tags = tagsPart.length ? tagsPart.join('/').split('+') : [];
    
    return { base, tags };
  }

  handleTagClick(event, button) {
    event.preventDefault();
    event.stopPropagation();

    // 1) Récupérer l’URL courante
    const url = new URL(window.location.href);
    const { base, tags } = this.extractCollectionAndTags();
    const clickedTag = button.dataset.tag;

    // Définir les groupes de tags mutuellement exclusifs
    const exclusiveGroups = {
      type: ['VAE', 'Musculaire', 'Speedbike'],
      tailleMini: ['Moins-de-145cm', 'Moins-de-150cm', 'Moins-de-155cm', 'Moins-de-160cm', 'Moins-de-165cm'],
      tailleMaxi: ['Plus-de-185cm', 'Plus-de-190cm', 'Plus-de-195cm', 'Plus-de-200cm', 'Plus-de-205cm'],
      poids: ['Moins-de-10kg', 'Moins-de-15kg', 'Moins-de-20kg', 'Moins-de-25kg', 'Moins-de-30kg', 'Moins-de-35kg', 'Moins-de-40kg'],
      charge: ['100-149kg', '150-174kg', '175-199kg', '200-224kg', '225-249kg', '250kg-et-plus'],
      batterie: ['Moins-de-500wh', '500-599Wh', '600-699Wh', '700-799Wh', '800-999Wh', '1000Wh-et-plus']
    };

    // 2) Trouver à quel groupe appartient le tag cliqué
    let clickedTagGroup = null;
    for (const [group, groupTags] of Object.entries(exclusiveGroups)) {
      if (groupTags.includes(clickedTag)) {
        clickedTagGroup = group;
        break;
      }
    }

    // 3) Dans le drawer => simple mise à jour visuelle
    if (button.closest('.facet-drawer')) {
      if (button.classList.contains('selected')) {
        // Désélection simple
        button.classList.remove('selected');
        button.style.backgroundColor = '#ffffff';
        button.style.border = '1px solid #ddedff';
      } else {
        // Si le tag fait partie d'un groupe exclusif
        if (clickedTagGroup) {
          const drawer = button.closest('.facet-drawer');
          exclusiveGroups[clickedTagGroup].forEach(groupTag => {
            const otherButton = drawer.querySelector(`.filter-tag[data-tag="${groupTag}"]`);
            if (otherButton && otherButton !== button) {
              otherButton.classList.remove('selected');
              otherButton.style.backgroundColor = '#ffffff';
              otherButton.style.border = '1px solid #ddedff';
            }
          });
        }
        // Sélectionner le nouveau tag
        button.classList.add('selected');
        button.style.backgroundColor = '#ddedff';
        button.style.border = '1px solid #ddedff';
      }
    } else {
      // 4) Hors du drawer => on modifie réellement l’URL
      let newTags;
      if (tags.includes(clickedTag)) {
        newTags = tags.filter(t => t !== clickedTag);
      } else {
        if (clickedTagGroup) {
          // Retirer tous les tags du même groupe, puis ajouter celui-ci
          newTags = tags.filter(t => !exclusiveGroups[clickedTagGroup].includes(t));
          newTags.push(clickedTag);
        } else {
          newTags = [...tags, clickedTag];
        }
      }

      // 4.1) Reconstituer la partie "path" (ex: /collections/xxx/VAE+VTC )
      const newPath = newTags.length > 0
        ? `${base}/${newTags.join('+')}`
        : base;

      // 4.2) Conserver la query string existante (ex: ?filter.p.vendor=...&sort_by=...)
      const currentQuery = url.search; // ex: "?filter.p.vendor=Moustache&sort_by=..."

      // 4.3) Construire l’URL complète
      const newUrl = `${newPath}${currentQuery}`;

      // 4.4) Mettre à jour l’historique
      window.history.pushState({}, '', newUrl);

      // 4.5) IMPORTANT: On passe la "searchParams" à FacetFiltersForm
      //     => ex: "filter.p.vendor=Moustache&sort_by=title-descending"
      const queryWithoutQuestionMark = url.searchParams.toString();

      // 4.6) On appelle FacetFiltersForm.renderPage avec la bonne query
      FacetFiltersForm.renderPage(queryWithoutQuestionMark, event);
    }
  }

  updateButtonStates() {
    const { tags } = this.extractCollectionAndTags();
    
    document.querySelectorAll('.filter-tag').forEach(button => {
      const tag = button.dataset.tag;
      const isSelected = tags.includes(tag);
      
      button.classList.toggle('selected', isSelected);
      
      if (isSelected) {
        button.style.backgroundColor = '#ddedff';
        button.style.border = '1px solid #ddedff';
      } else {
        button.style.backgroundColor = '#ffffff';
        button.style.border = '1px solid #ddedff';
      }
    });
  }

  updateActiveFacets() {
    const container = document.querySelector('.custom-tag-filters');
    if (!container) return;

    const { tags } = this.extractCollectionAndTags();
    container.innerHTML = '';
    
    // Ajouter les tags actifs
    tags.forEach(tag => {
      const link = document.createElement('a');
      link.href = '#';
      link.className = 'active-facets__button';
      link.innerHTML = `
        ${tag}
        <span>
          <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" 
            xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" 
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      `;
      
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const newTags = tags.filter(t => t !== tag);
        const newPath = newTags.length > 0
          ? `${this.getBaseCollectionUrl()}/${newTags.join('+')}`
          : this.getBaseCollectionUrl();

        // Conserver la query string
        const currentQuery = window.location.search;
        const finalUrl = `${newPath}${currentQuery}`;

        window.location = finalUrl; // Recharge la page
      });

      container.appendChild(link);
    });

    // Vérifier s'il y a des filtres actifs ou des tags actifs
    const activeFacets = document.querySelector('facet-remove');
    if (activeFacets) {
      const hasShopifyFilters = activeFacets.querySelectorAll('.active-facets__button:not([data-custom-tag])').length > 0;
      const hasCustomTags = tags.length > 0;

      // Cacher ou afficher le bouton "Tout supprimer" en fonction de la présence de filtres
      const clearButton = activeFacets.querySelector('.active-facets__button-remove');
      if (clearButton) {
        if (!hasShopifyFilters && !hasCustomTags) {
          clearButton.style.display = 'none';
        } else {
          clearButton.style.display = '';
        }
      }
    }
  }
}

// Initialisation
const initializeTagFilters = () => {
  window.tagFilters = new TagFilters();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTagFilters);
} else {
  initializeTagFilters();
}